// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1Icgm","icon":"SortAdornment_icon__3yQPs","up":"SortAdornment_up__wpHUC","down":"SortAdornment_down__3dq2b","active":"SortAdornment_active__2-1GK"};